/**
 * 项目统一配置
 */
export default {
  version: '1.0',
  name: '河北智校园', // 项目名称
  // baseURL: 'http://192.168.2.48:8082/api', // 测试接口地址
  baseURL: 'https://wwwapi.hdzxy.com', // 生产接口地址
  whiteList: ['/login', '/forget', '/hdLogin', '/testTree', '/test', '/dorDataV'], // 路由白名单(不需要登录的)
  keepAliveList: [], // 需要缓存的组件名称
  menuUrl: '/school/schoolMenu/getSchoolTeacherMenuList', // 菜单数据接口
  parseMenu: null, // 自定义解析接口菜单数据
  parseMenuItem: (item) => {
    // 自定义解析接口菜单每一个数据格式
    item.path = item.url;
    item.title = item.menuName;
    return item;
  },
  userUrl: '/school/teacher/detail', //用户信息接口
  parseUser: null,
  tokenReponseName: 'authorization', //token自动续期返回的字段
  tokenHeaderName: 'token', // token传递的header名称
  tokenStoreName: 'access_token', // token存储的名称
  userStoreName: 'user', // 用户信息存储的名称
  themeStoreName: 'theme', // 主题配置存储的名称
  homeTitle: '主页', // 首页Tab显示标题,null会根据菜单自动获取
  watchResize: true, // 是否监听屏幕尺寸改变
  showSetting: true, // 是否显示主题设置抽屉
  /* 主题默认配置 */
  sideStyle: 0, // 侧边栏风格,0默认,1暗色
  headStyle: 2, // 顶栏风格,0默认,1暗色,2主色
  tabStyle: 1, // 标签页风格,0默认(下划线),1圆点,2卡片
  bodyFull: true, // 内容区域宽度铺满
  layoutStyle: 0, // 布局风格,0默认,1顶部菜单风格,2混合菜单风格
  theme: null, // 默认主题
  showTabs: true, // 是否开启多标签
  logoAutoSize: true, // logo是否自适应宽度
  fixedLayout: true, // 是否固定顶栏和侧栏
  colorfulIcon: true, // 侧栏是否多彩图标
  sideUniqueOpen: true, // 侧边栏是否只保持一个子菜单展开
};
